import { makeStyles, typographyStyles } from '@fluentui/react-components';

export const useSelectionCountStyles = makeStyles({
  root: {
    ...typographyStyles.body1Strong,
  },
});
